import { useEffect, useState } from "react";

/**
 * Trails `value` by `delay` ms.
 *
 * Used to drive server-side search params from a text input: without it every
 * keystroke is a request, and the responses can land out of order so the list
 * settles on a stale query.
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
